import React from 'react'
import { toMoney } from '../../src/Utilities'

const CurrentDuesStatement: React.FC<{countyName: string, nextDuesAmount: number}> = (props) => {
    return <>
        <b>Currently</b>, {props.countyName} annual dues are <b>{toMoney(props.nextDuesAmount)}</b> per year.
    </>
}

export default CurrentDuesStatement